// Form Purpose — what a per-property form is FOR (distinct from Form Style, which
// is how it is built/rendered). Primary is scoped per (property, purpose): a
// property may have several forms of one purpose, with one marked Primary.
// Values are stable slugs; labels/descriptions are display-only (code-standards F4).
export const FORM_PURPOSES = [
  {
    value: 'visitor_check_in',
    label: 'Visitor Check-in / Check-out',
    description: 'Record presence, destination, host, emergency details and induction completion.',
  },
  {
    value: 'contractor_check_in',
    label: 'Contractor Check-in / Check-out',
    description: 'Contractor presence, site access, induction and check-out for the property.',
  },
  {
    value: 'worker_induction',
    label: 'Worker Induction',
    description: 'General property and organisational induction.',
  },
  {
    value: 'contractor_induction',
    label: 'Contractor Induction',
    description: 'Site-specific hazards, emergency procedures, permitted work and responsibilities.',
  },
  {
    value: 'task_specific_induction',
    label: 'Task-specific Induction',
    description: 'Induction for particular machinery, animals, chemicals or work areas.',
  },
  {
    value: 'pre_starts',
    label: 'Pre-Starts',
    description: 'Pre-start checks completed before beginning work, plant or an activity.',
  },
  {
    value: 'contractor_prequalification',
    label: 'Contractor Prequalification',
    description: 'ABN, insurance, licences, competencies, SWMS and expiry dates.',
  },
  {
    value: 'licence_competency_verification',
    label: 'Licence and Competency Verification',
    description: 'Confirm licences, tickets, experience and supervisor approval.',
  },
  {
    value: 'policy_procedure_acknowledgement',
    label: 'Policy and Procedure Acknowledgement',
    description: 'Worker confirms they have received and understood a policy or SOP.',
  },
  {
    value: 'toolbox_talk_record',
    label: 'Toolbox Talk Record',
    description: 'Topic, attendees, concerns raised and actions assigned.',
  },
  {
    value: 'training_competency_assessment',
    label: 'Training and Competency Assessment',
    description: 'Training completed, practical assessment, restrictions and reassessment date.',
  },
  {
    value: 'ppe_issue_acknowledgement',
    label: 'PPE Issue and Acknowledgement',
    description: 'PPE supplied, condition, training and replacement date.',
  },
  {
    value: 'children_family_on_farm_assessment',
    label: 'Children and Family Members on Farm Assessment',
    description: 'Restricted areas, supervision requirements and prohibited activities.',
  },
  {
    value: 'other',
    label: 'Other',
    description: 'To capture all other forms.',
  },
];

// The purposes that make a form runnable as a visitor induction. A form needs
// one of these (and a schema) to appear under "Run Induction" on a visitor
// record. Mirrors Form::inductionPurposes() in the backend.
export const INDUCTION_PURPOSES = [
  'worker_induction',
  'contractor_induction',
  'task_specific_induction',
];

export const isInductionPurpose = (value) => INDUCTION_PURPOSES.includes(value);

export const FORM_PURPOSE_VALUES = FORM_PURPOSES.map((p) => p.value);

export const getFormPurposeLabel = (value) => {
  const match = FORM_PURPOSES.find((p) => p.value === value);
  return match ? match.label : (value || '');
};
